import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useGetDealerComparisonPricesByTireSize } from "../../queries/useGetDealerComparisonPricesByTireSize";
import { HashtagString, createHashStateHook } from "../../stores/useHashState";
import { Dialog } from "../../ui/Dialog/Dialog";
import { DialogHeader } from "../../ui/Dialog/DialogHeader";
import { LinearProgress } from "../../ui/LinearProgress";
import { CmsLink } from "./CmsLink";
import { PricingAnalysisForm } from "./PricingAnalysisForm";
import { PricingAnalysisTable } from "./PricingAnalysisTable";
import { usePricingAnalysisSetting } from "./usePricingAnalysisSetting";
import { usePricingAnalysisState } from "./usePricingAnalysisState";

export const pricingAnalysisHash: HashtagString = "#pricing-analysis";

const usePricingAnalysis = createHashStateHook(pricingAnalysisHash);

export const PricingAnalysisModal: FunctionComponent = () => {
  const [visible, { hide }] = usePricingAnalysis();
  const setting = usePricingAnalysisSetting();
  const { t } = useTranslation();
  const state = usePricingAnalysisState();

  const { data, isLoading } = useGetDealerComparisonPricesByTireSize(
    state.tireSize,
    { keepPreviousData: true }
  );

  if (!setting) {
    return null;
  }

  return (
    <Dialog
      className={clsx(Boolean(data) && "w-full")}
      id="pricing-analysis-modal"
      onClose={hide}
      placement="top"
      visible={visible}
    >
      <DialogHeader onClose={hide} title={t("pricingAnalysis.header")} />
      <section className="p-4">
        <PricingAnalysisForm data={data} state={state} />
        <CmsLink />
        {isLoading && <LinearProgress className="h-[0.1rem]" />}
        {data && <PricingAnalysisTable data={data} state={state} />}
      </section>
    </Dialog>
  );
};
